import { useCallback } from 'react';
import { useUpdateTagsOrderMutation } from 'shared/hooks/queries/use-update-tags-order-mutation';
import { ID } from 'shared/types/id';

export const useReorderTags = () => {
  const { mutate: updateOrder } = useUpdateTagsOrderMutation();

  return useCallback((ids: ID[]) => updateOrder(ids), [updateOrder]);
};
